import { render, staticRenderFns } from "./OffersComponent.vue?vue&type=template&id=9195f31a&scoped=true&"
import script from "./OffersComponent.vue?vue&type=script&lang=ts&"
export * from "./OffersComponent.vue?vue&type=script&lang=ts&"
import style0 from "./OffersComponent.vue?vue&type=style&index=0&id=9195f31a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9195f31a",
  null
  
)

export default component.exports